import React from "react";

export default function AppShell({ children, className = "" }) {
  return (
    <div className="app-shell" data-testid="app-shell">
      <div className={`screen-enter ${className}`}>{children}</div>
    </div>
  );
}
